import React from 'react';
import LegalLayout from './LegalLayout';

export default function Cookies() {
  return (
    <LegalLayout title="Политика cookie" updated="16 сентября 2026 года">
      <p>
        Настоящая Политика использования файлов cookie и иных технологий
        отслеживания (далее — «Политика») определяет порядок использования файлов
        cookie, веб-маяков, пикселей, идентификаторов устройств, скриптов аналитики
        и иных аналогичных технологий на сайте https://mailora.ru (далее — «Сайт»)
        и в приложении Сервиса в соответствии с Федеральным законом от 27.07.2006
        № 152-ФЗ «О персональных данных», Федеральным законом от 27.07.2006
        № 149-ФЗ «Об информации, информационных технологиях и о защите информации»
        и иными нормативными правовыми актами Российской Федерации.
      </p>
      <p>
        Политика опубликована в свободном доступе на Сайте и является обязательной
        для ознакомления всеми пользователями Сервиса Mailora.
      </p>
      <p>
        Оператор оставляет за собой право вносить изменения в настоящую Политику в
        случае изменения процессов обработки данных, внедрения новых технологий,
        расширения функционала Сервиса или изменения требований законодательства
        Российской Федерации. Актуальная версия Политики размещается на Сайте.
        Продолжение использования Сайта и Сервиса после опубликования новой
        редакции Политики считается согласием пользователя с внесёнными
        изменениями.
      </p>

      <h2>1. Общие положения</h2>
      <p>
        1.1. Настоящая Политика является неотъемлемой частью Политики обработки
        персональных данных Оператора и Публичной оферты сервиса Mailora. Она
        регулирует использование технологий, позволяющих хранить и получать
        информацию с устройства пользователя при посещении Сайта, использовании
        приложения и взаимодействии с Оператором.
      </p>
      <p>
        1.2. <strong>Файлы cookie</strong> — это небольшие текстовые файлы, которые
        сохраняются на устройстве пользователя (компьютер, планшет, мобильный
        телефон и т.п.) при посещении Сайта или использовании Сервиса и применяются
        для хранения информации о действиях и предпочтениях пользователя, а также
        для обеспечения корректной работы Сервиса.
      </p>
      <p>
        1.3. <strong>Иные технологии отслеживания</strong> включают в себя
        веб-маяки, пиксели, идентификаторы устройств, сессионные токены, скрипты
        аналитики, fingerprint браузера и аналогичные инструменты, позволяющие
        собирать данные о взаимодействии пользователя с Сайтом и Сервисом, его
        поведении и технических характеристиках устройства.
      </p>
      <p>
        1.4. Указанные технологии применяются Оператором для обеспечения корректной
        и бесперебойной работы Сервиса, функционирования регистрации и авторизации,
        сохранения сессии, работы встроенного инбокса, управления рассылками,
        обеспечения безопасности, а также (при наличии согласия) для аналитики
        использования Сервиса.
      </p>

      <h2>2. Перечень категорий cookie и иных технологий</h2>
      <p>
        Оператор использует следующие категории файлов cookie и иных технологий
        отслеживания:
      </p>
      <p>
        <strong>2.1. Строго необходимые (технические / обязательные) cookie.</strong>{' '}
        Необходимы для обеспечения базовой функциональности Сервиса: работы
        регистрации и авторизации (в том числе через сквозную авторизацию),
        сохранения сессии пользователя, корректного отображения интерфейса, работы
        Личного кабинета, обеспечения безопасности. Без этих cookie Сервис не может
        полноценно функционировать (в частности, невозможна авторизация и
        сохранение состояния пользователя).
      </p>
      <p>
        Строго необходимые cookie используются без получения отдельного согласия
        пользователя.
      </p>
      <p>
        Сервис также использует технологии локального хранения данных
        (localStorage, sessionStorage) и fingerprint браузера для обеспечения
        работы авторизации, безопасности и сохранения состояния приложения.
        Указанные технологии относятся к строго необходимым.
      </p>
      <p>
        <strong>2.2. Аналитические cookie.</strong> Используются для сбора
        статистической информации о посещаемости Сайта и использовании Сервиса,
        поведении пользователей и эффективности работы платформы. Оператор
        применяет сервисы Yandex Metrica и App Metrica.
      </p>
      <p>
        На лендинге Сайта при первом посещении отображается баннер об использовании
        cookie. Аналитические cookie применяются после получения согласия
        пользователя (либо в случаях, когда это допускается законодательством).
      </p>
      <p>
        Отключение аналитических cookie может ограничить возможность Оператора
        анализировать и улучшать Сервис, но не влияет на возможность использования
        основных функций (авторизация, подключение ящиков, загрузка баз, настройка
        цепочек и авторассылок, персонализация, инбокс).
      </p>

      <h2>3. Цели использования cookie и иных технологий отслеживания</h2>
      <p>Файлы cookie и иные технологии используются Оператором в следующих целях:</p>
      <ul>
        <li>обеспечение корректной и бесперебойной работы Сервиса, включая функционирование регистрации, авторизации, встроенного инбокса, управления рассылками и сохранения сессии;</li>
        <li>сохранение состояния сессии пользователя и обеспечение безопасности;</li>
        <li>анализ посещаемости и поведения пользователей на Сайте и в Сервисе для улучшения качества Сервиса, пользовательского интерфейса и удобства использования;</li>
        <li>сбор статистической информации о количестве посетителей, наиболее популярных разделах, источниках переходов и эффективности работы платформы;</li>
        <li>обеспечение безопасности Сервиса и предотвращение несанкционированного доступа;</li>
        <li>соблюдение требований законодательства Российской Федерации в области защиты персональных данных и информационной безопасности.</li>
      </ul>

      <h2>4. Перечень собираемых данных</h2>
      <p>
        С помощью файлов cookie и иных технологий отслеживания могут собираться
        следующие данные (в том числе в обезличенном или псевдоанонимизированном
        виде):
      </p>
      <ul>
        <li>IP-адрес устройства пользователя;</li>
        <li>тип и версия браузера, операционная система, модель устройства, разрешение экрана, fingerprint браузера;</li>
        <li>сведения о действиях на Сайте и в Сервисе (просмотренные страницы, время пребывания, переходы между разделами, использование функций);</li>
        <li>уникальные идентификаторы сессии и технические параметры соединения;</li>
        <li>данные об источнике перехода на Сайт;</li>
        <li>иные технические данные, необходимые для функционирования Сервиса, авторизации и аналитики.</li>
      </ul>
      <p>
        Все данные обрабатываются в соответствии с Политикой обработки персональных
        данных Оператора, размещённой на Сайте.
      </p>

      <h2>5. Использование сторонних сервисов аналитики</h2>
      <p>Оператор использует следующие сторонние сервисы аналитики:</p>
      <ul>
        <li>Yandex Metrica — для сбора статистических данных о посещаемости Сайта и поведении пользователей;</li>
        <li>App Metrica — для сбора и анализа данных об использовании функционала Сервиса.</li>
      </ul>
      <p>
        Указанные сервисы устанавливают собственные cookie и собирают данные в
        соответствии со своими политиками конфиденциальности. Оператор передаёт им
        данные в объёме, необходимом для целей аналитики.
      </p>

      <h2>6. Передача данных третьим лицам</h2>
      <p>
        Данные, собираемые с помощью файлов cookie и иных технологий отслеживания,
        могут передаваться третьим лицам (сервисам аналитики) в объёме, необходимом
        для достижения целей, указанных в разделе 3 настоящей Политики.
      </p>
      <p>
        Передача осуществляется при условии обеспечения конфиденциальности и
        безопасности данных в соответствии с требованиями Федерального закона
        № 152-ФЗ.
      </p>

      <h2>7. Трансграничная передача данных</h2>
      <p>
        Данные, собираемые сервисами аналитики, обрабатываются в соответствии с их
        собственными политиками. Если инфраструктура соответствующего сервиса
        расположена за пределами Российской Федерации, передача таких данных
        осуществляется при наличии законных оснований и с соблюдением требований
        законодательства Российской Федерации о персональных данных. Согласие на
        такую передачу выражается пользователем путём явного действия в
        cookie-баннере при посещении лендинга Сайта в соответствии с разделом 8
        настоящей Политики.
      </p>

      <h2>8. Способ выражения согласия</h2>
      <p>
        Согласие пользователя на использование аналитических cookie и иных
        технологий отслеживания выражается исключительно путём явного действия в
        cookie-баннере, который отображается при первом посещении лендинга Сайта.
        Пользователь подтверждает согласие нажатием соответствующей кнопки в
        баннере («Принять», «Согласен» или аналогичной).
      </p>
      <p>
        Строго необходимые (технические) cookie используются без получения
        отдельного согласия, поскольку они необходимы для корректной работы
        Сервиса, регистрации, авторизации, сохранения сессии и предоставления
        основных функций.
      </p>
      <p>
        Внутри Сервиса сбор аналитических данных осуществляется на основании
        Согласия на обработку персональных данных, принимаемого Пользователем при
        регистрации. Cookie-баннер относится к посетителям Сайта, не прошедшим
        авторизацию.
      </p>
      <p>
        Продолжение использования Сайта и Сервиса после закрытия баннера без
        выражения согласия не рассматривается как согласие на использование
        аналитических cookie. В этом случае аналитические cookie не устанавливаются.
      </p>

      <h2>9. Возможность отзыва согласия и способы отключения cookie</h2>
      <p>
        Пользователь вправе в любое время отозвать своё согласие на использование
        аналитических cookie и иных технологий отслеживания (кроме строго
        необходимых) путём:
      </p>
      <ul>
        <li>направления уведомления Оператору на электронную почту contact@mailora.ru;</li>
        <li>изменения настроек своего браузера (отключение или удаление cookie);</li>
        <li>использования специальных плагинов и расширений браузера для управления cookie.</li>
      </ul>
      <p>
        После отзыва согласия Оператор прекращает дальнейшую загрузку аналитики в
        доступном ему объёме. Строго необходимые технические cookie продолжают
        использоваться, поскольку без них невозможна полноценная работа Сервиса.
      </p>
      <p>
        Пользователь уведомляется, что полное отключение или блокирование всех
        cookie (включая строго необходимые) может привести к ограничению или
        невозможности использования функционала Сервиса (авторизация, сохранение
        сессии, корректное отображение интерфейса и т.п.).
      </p>
      <p>
        Отзыв согласия не влияет на законность обработки данных, осуществлённой до
        момента отзыва.
      </p>

      <h2>10. Срок действия Политики</h2>
      <p>
        Настоящая Политика действует с момента её публикации на Сайте и до момента
        внесения изменений или отмены. Оператор вправе вносить изменения в
        Политику. Новая редакция вступает в силу с момента размещения на Сайте.
      </p>

      <h2>11. Реквизиты Оператора</h2>
      <p>
        Индивидуальный предприниматель Сидоренко Руслан Владимирович
        <br />
        ОГРНИП: 317619600088799
        <br />
        ИНН: 611300126009
        <br />
        Адрес электронной почты технической поддержки: support@mailora.ru
        <br />
        Адрес электронной почты для вопросов персональных данных: contact@mailora.ru
        <br />
        Режим работы: 9:00–18:00 МСК, за исключением праздничных и выходных дней.
        <br />
        Сайт: www.mailora.ru
      </p>
      <p>
        Актуальная версия Политики постоянно доступна по адресу
        https://mailora.ru/cookies.
      </p>
      <p>Дата публикации настоящей редакции: 16 сентября 2026 года.</p>

      <h2>Контакты</h2>
      <p>
        По вопросам обработки персональных данных и использования cookie:{' '}
        <a href="mailto:contact@mailora.ru">contact@mailora.ru</a>
      </p>
    </LegalLayout>
  );
}